import { customScrollMinimal, SmartTable, values } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  overflow-x: auto;
  ${customScrollMinimal};

  ${SmartTable.Styled.Table} {
    th,
    td {
      background-color: var(--background-soft);
    }

    thead tr th {
      border-bottom: 1px solid var(--border-default);
      white-space: pre-wrap;
      padding: 0px 12px 12px 12px;

      &:last-child {
        width: 1%;
        white-space: nowrap;
      }
    }

    tbody {
      tr {
        cursor: pointer;

        &:last-child td {
          border-bottom: none;

          &:first-child {
            border-bottom-left-radius: ${values.r2};
          }

          &:last-child {
            border-bottom-right-radius: ${values.r2};
          }
        }
      }

      td {
        min-height: 28px;

        &:last-child {
          width: 1%;
          white-space: nowrap;
        }
      }
    }
  }
`;
